import { GridRowProps } from '@mui/x-data-grid-pro';

export enum AccountStatementItemType {
    CREDIT_NOTE = 'CREDIT_NOTE',
    INVOICE = 'INVOICE',
    PAYMENT = 'PAYMENT',
    BALANCE = 'BALANCE',
}

export interface AccountStatementTableData extends GridRowProps {
    id: string;
    transactionDate: string;
    description: string;
    credit?: string;
    debit?: string;
    invoiceId?: string;
    creditNoteId?: string;
    paymentMethod?: string;
    paymentId?: number;
    accountStatementId: string;
    itemType: AccountStatementItemType;
    createdAt: string;
    rollingBalance: number;
}
